import { useAuthDataContext } from "components/auth";
import { getRecordingFileUrl } from "config/paths";

export default (recordingId, fileId) => {
  const { token } = useAuthDataContext();
  return getRecordingFileUrl(recordingId, fileId, token);
};
